import React, { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { UPDATE_USER_STATUS_FAILURE, UPDATE_USER_STATUS_SUCCESS, updateUserStatus } from '../../Redux/Actions/Actions'
import FormLoader from '../Reusable_Components/FromLoader'
import { Button, Modal } from 'react-bootstrap'
import { MdErrorOutline } from 'react-icons/md'
import NavBarTop from '../Reusable_Components/NavBarTop'
import LeftNavBar from '../Reusable_Components/LeftNavBar'
import Footer from "../Login/Footer.jsx";
import { encrypt } from '../Reusable_Components/ReusableFunctions'

export default function EditUser(props) {

    const dispatch = useDispatch()

    let user = props?.userData

    const updateUserStatusSuccess = useSelector(state => state.updateUserStatusSuccess)
    const updateUserStatusFailure = useSelector(state => state.updateUserStatusFailure)
    const loading = useSelector(state => state.loading)

    const [status, setStatus] = useState(user.status ? "Active" : "Inactive")
    const [updateDisable, setUpdateDisable] = useState(true)

    const handleUpdateStatus = (username) => {
        let userStatus = status === "Active" ? "true" : "false"
        let data = {
            status: userStatus,
            username: username
        }
        dispatch(updateUserStatus(encrypt(data)))
    }

    return (
        <>
            <>
                <NavBarTop />
                <LeftNavBar />
            </>
            <div className="addUserContainer">
                {loading && <FormLoader />}
                <div className="stepsContainer">
                    <div className="stepsTitle">
                        <h6 className='stepsTitle_heading'>Edit User</h6>
                    </div>
                    <div className={'stepsCardActive'}>
                        <div className='stepsCardHeader'>
                            <span className='stepsCardTitle '>User Information</span>
                        </div>
                        <span className='stepsCardDescription'>User Details</span>
                    </div>
                </div>
                <div className="infoContainer">
                    <div className="infoTitle">
                        <h6 className='stepsTitle_heading'>1. User Information</h6>
                    </div>
                    <div className="infoBody">
                        <div>
                            <h7 className='info_heading'>User Details</h7>
                            <div className='d-flex flex-column gap-3 mt-3'>
                                <div className='d-flex align-items-center gap-2 '>
                                    <label className='info_label'>Full Name<span className='text-danger'>*</span></label>
                                    <input type="text" disabled placeholder="Enter Full Name" value={user.name} className='form-control' />
                                </div>
                                <div className='d-flex align-items-center gap-2 '>
                                    <label className='info_label'>Username<span className='text-danger'>*</span></label>
                                    <input type="text" disabled placeholder="Enter Username" value={user.username} className='form-control' />
                                </div>
                                <div className='d-flex align-items-center gap-2 '>
                                    <label className='info_label'>Email<span className='text-danger'>*</span></label>
                                    <input type="email" disabled placeholder="Enter Email" value={user.email} className='form-control' />
                                </div>
                                <div className='d-flex align-items-center gap-2 '>
                                    <label className='info_label'>Phone Number<span className='text-danger'>*</span></label>
                                    <div className='d-flex align-items-center' style={{ width: "100%" }}>
                                        <input type="text" placeholder="Enter Phone number" value={user.phone_number} className='form-control noSpinArrows input-phn-no' disabled />
                                    </div>
                                </div>
                                <div className='d-flex align-items-center gap-2 '>
                                    <label className='info_label'>Group<span className='text-danger'>*</span></label>
                                    <select className='form-control select-input' disabled value={user.group_name}>
                                        <option hidden >Select a Group</option>
                                        <option>Commercial Head</option>
                                        <option>Facility Manager</option>
                                        <option>Finance Manager</option>
                                        <option>Technician</option>
                                        <option>CEO</option>
                                        <option>Customer</option>
                                    </select>
                                </div>
                                <div className='d-flex align-items-center gap-2 '>
                                    <label className='info_label'>Status<span className='text-danger'>*</span></label>
                                    <select className='fin_man_meter_dropdown group_select_dropdown' value={status} onChange={(e) => {
                                        setStatus(e.target.value)
                                        setUpdateDisable(false)
                                    }}
                                        disabled={localStorage.getItem("username") === user.username}
                                    >
                                        <option hidden >Select a Status</option>
                                        <option value={"Active"}>Active</option>
                                        <option value={"Inactive"}>Inactive</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="infoFotter">
                        <div className="d-flex justify-content-end gap-3">
                            <button className="btn btn-primary secondary-button" onClick={() => props?.setPage(1)}>Back</button>
                            <button className="btn btn-primary primary-button" disabled={updateDisable || status === (user.status ? "Active" : "Inactive")} onClick={() => handleUpdateStatus(user.username)}>Update</button>
                        </div>
                    </div>
                </div>
                {updateUserStatusSuccess && <Modal keyboard={false} backdrop="static" show={updateUserStatusSuccess} onHide={() => {
                    dispatch({
                        type: UPDATE_USER_STATUS_SUCCESS,
                        payload: null
                    })
                }} centered className="popper-modal">
                    <Modal.Body className="text-center">
                        <img src="./images/icons/popper.svg" alt="Party Popper" />
                        <h5>Success!</h5>
                        <p className="mb-3">{updateUserStatusSuccess}</p>
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-center" >
                        <Button variant="secondary" className="secondary" onClick={() => {
                            dispatch({
                                type: UPDATE_USER_STATUS_SUCCESS,
                                payload: null
                            })
                            props?.setPage(1)
                        }} >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>}
                {updateUserStatusFailure && <Modal keyboard={false} backdrop="static" show={updateUserStatusFailure} onHide={() => {
                    dispatch({
                        type: UPDATE_USER_STATUS_FAILURE,
                        payload: null
                    })
                }} centered className="popper-modal">
                    <Modal.Body className="text-center">
                        <MdErrorOutline color='red' className='error-icon'/>
                        <h5>Error!</h5>
                        <p className="mb-3">{updateUserStatusFailure}</p>
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-center" >
                        <Button variant="secondary" className="secondary" onClick={() => {
                            dispatch({
                                type: UPDATE_USER_STATUS_FAILURE,
                                payload: null
                            })
                        }} >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>}
            </div>
            <Footer />

        </>
    )
}
